import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jobsAPI } from '../api';
import { useAuth } from '../context/AuthContext';

const STATUS_COLORS = { escrow:'#6DBE45',active:'#00E676',complete:'#1E7FD4',cancelled:'#FF4757',disputed:'#FF4757' };

export default function CustomerDashboard() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(()=>{ jobsAPI.mine().then(r=>setJobs(r.data)).catch(()=>{}).finally(()=>setLoading(false)); },[]);

  return (
    <div className="page-container">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:28,flexWrap:'wrap',gap:12}}>
        <div>
          <div className="section-title">My Jobs</div>
          <div className="section-sub">{user?.first_name} {user?.last_name} {user?.company&&`· ${user.company}`}</div>
        </div>
        <button className="btn btn-primary" onClick={()=>nav('/browse')}>+ Hire a Pro</button>
      </div>

      {loading ? <div style={{textAlign:'center',padding:60}}><span className="spinner"/></div>
      : jobs.length===0 ? (
        <div style={{textAlign:'center',padding:'60px 0',color:'#445566'}}>
          <div style={{fontSize:40,marginBottom:12}}>🔍</div>
          <div style={{fontSize:16,marginBottom:16}}>No jobs yet</div>
          <button className="btn btn-primary" onClick={()=>nav('/browse')}>Browse Professionals →</button>
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          {jobs.map(j=>(
            <div key={j.id} className="card" style={{padding:20}}>
              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',flexWrap:'wrap',gap:10}}>
                <div style={{flex:1}}>
                  <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:6,flexWrap:'wrap'}}>
                    <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:16,fontWeight:700,color:'#F0F6FF'}}>
                      {j.service_name}
                    </span>
                    <span style={{fontSize:11,fontWeight:700,padding:'3px 8px',borderRadius:4,textTransform:'uppercase',
                      background:`${STATUS_COLORS[j.status]||'#8899AA'}18`,color:STATUS_COLORS[j.status]||'#8899AA',
                      border:`1px solid ${STATUS_COLORS[j.status]||'#8899AA'}44`}}>
                      {j.status}
                    </span>
                  </div>
                  <div style={{fontSize:13,color:'#8899AA',marginBottom:4}}>
                    {j.market_name} · {j.start_date ? new Date(j.start_date).toLocaleDateString() : 'TBD'}
                    {j.hours_estimated && ` · ${j.hours_estimated}h estimated`}
                  </div>
                  <div style={{fontSize:13,color:'#556677',marginBottom:8}}>
                    Provider: <strong style={{color:'#AAB8C8'}}>{j.provider_name || j.code_id}</strong>
                    {j.provider_phone && <> · {j.provider_phone}</>}
                  </div>
                  {j.description && <div style={{fontSize:12,color:'#445566'}}>{j.description}</div>}
                </div>
                <div style={{textAlign:'right',flexShrink:0}}>
                  <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:24,fontWeight:800,color:'#1E7FD4'}}>
                    ${parseFloat(j.total_charged||0).toFixed(2)}
                  </div>
                  <div style={{fontSize:11,color:'#445566'}}>@ ${j.rate_hr}/hr</div>
                  {j.status==='complete' && !j.reviewed && (
                    <button className="btn btn-sm btn-primary" style={{marginTop:8}}
                      onClick={()=>nav(`/review/${j.id}`)}>Leave Review</button>
                  )}
                </div>
              </div>
              <div style={{fontSize:11,color:'#334455',marginTop:8}}>
                Job #{j.id?.slice(0,8).toUpperCase()}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Footer ad */}
      <div style={{marginTop:32,background:'linear-gradient(135deg,#0F1F38,#1A2B45)',border:'1px solid rgba(245,166,35,0.15)',
        borderRadius:12,padding:'20px 24px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:16,flexWrap:'wrap'}}>
        <div>
          <div style={{fontSize:10,letterSpacing:2,textTransform:'uppercase',color:'#6DBE45',fontWeight:600,marginBottom:4}}>Sponsored</div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:20,fontWeight:700}}>Fluke Networks DSX2-8000</div>
          <div style={{fontSize:13,color:'#8899AA'}}>Industry-leading cable certification for BICSI-compliant installs.</div>
        </div>
        <button className="btn btn-ghost btn-sm">Learn More →</button>
      </div>
    </div>
  );
}
